module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Total"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Items per page"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Show buttons before current"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.rangeBefore),
      callback: function($$v) {
        _vm.rangeBefore = $$v
      },
      expression: "rangeBefore"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Show buttons after current"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.rangeAfter),
      callback: function($$v) {
        _vm.rangeAfter = $$v
      },
      expression: "rangeAfter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Order"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.order),
      callback: function($$v) {
        _vm.order = $$v
      },
      expression: "order"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-centered"
    }
  }, [_vm._v("is-centered")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-right"
    }
  }, [_vm._v("is-right")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Size"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.size),
      callback: function($$v) {
        _vm.size = $$v
      },
      expression: "size"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-small"
    }
  }, [_vm._v("is-small")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-medium"
    }
  }, [_vm._v("is-medium")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-large"
    }
  }, [_vm._v("is-large")])])], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Previous icon"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.prevIcon),
      callback: function($$v) {
        _vm.prevIcon = $$v
      },
      expression: "prevIcon"
    }
  }, [_c('option', {
    attrs: {
      "value": "chevron-left"
    }
  }, [_vm._v("Chevron")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "arrow-left"
    }
  }, [_vm._v("Arrow")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Next icon"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.nextIcon),
      callback: function($$v) {
        _vm.nextIcon = $$v
      },
      expression: "nextIcon"
    }
  }, [_c('option', {
    attrs: {
      "value": "chevron-right"
    }
  }, [_vm._v("Chevron")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "arrow-right"
    }
  }, [_vm._v("Arrow")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isSimple),
      callback: function($$v) {
        _vm.isSimple = $$v
      },
      expression: "isSimple"
    }
  }, [_vm._v("Simple")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.isRounded),
      callback: function($$v) {
        _vm.isRounded = $$v
      },
      expression: "isRounded"
    }
  }, [_vm._v("Rounded")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "total": _vm.total,
      "current": _vm.current,
      "range-before": _vm.rangeBefore,
      "range-after": _vm.rangeAfter,
      "order": _vm.order,
      "size": _vm.size,
      "simple": _vm.isSimple,
      "rounded": _vm.isRounded,
      "per-page": _vm.perPage,
      "icon-prev": _vm.prevIcon,
      "icon-next": _vm.nextIcon,
      "aria-next-label": "Next page",
      "aria-previous-label": "Previous page",
      "aria-page-label": "Page",
      "aria-current-label": "Current page"
    },
    on: {
      "update:current": function($event) {
        _vm.current = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dd59c88"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/pagination/examples/ExSimple.vue
// module id = 1145
// module chunks = 37 111